export default {
    getAlarmCycle: ({date, type = 1}) => {
        let dateIn = new Date(date)
        // 获取开始时间
        if (type == 3) {
            dateIn.setDate(dateIn.getDate() - 14)
        } else if (type == 1) {
            dateIn.setDate(dateIn.getDate() - 7)
        } else if (type == 2) {
            dateIn.setMonth(dateIn.getMonth() - 1)
        }

        let startDateIn = dateIn.getFullYear() + '-' + (dateIn.getMonth() + 1 < 10 ? '0' + (dateIn.getMonth() + 1) : dateIn.getMonth() + 1) + '-' + (dateIn.getDate() < 10 ? '0' + dateIn.getDate() : dateIn.getDate())
        console.log(startDateIn)

        let endDate = new Date(date)
        endDate.setDate(endDate.getDate() - 1)
        let endDateIn = endDate.getFullYear() + '-' + (endDate.getMonth() + 1 < 10 ? '0' + (endDate.getMonth() + 1) : endDate.getMonth() + 1) + '-' + (endDate.getDate() < 10 ? '0' + endDate.getDate() : endDate.getDate())
        console.log(endDateIn)
        return [startDateIn, endDateIn]
    },



    // 时间戳转换
    timeFormatSeconds(time) {
      var d = time ? new Date(time) : new Date();
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hours = d.getHours();
      var min = d.getMinutes();
      var seconds = d.getSeconds();

      if (month < 10) month = '0' + month;
      if (day < 10) day = '0' + day;
      if (hours <= 0) hours = '0' + hours;
      if (min < 10) min = '0' + min;
      if (seconds < 10) seconds = '0' + seconds;

      return (year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + seconds);
    },

    // 日期转换特定格式
    dateFormatTransfer(datetime) {
        let date = new Date(datetime)
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()

        return year + '.' + month + '.' + day
    }
}